export default __webpack_public_path__ + "static/media/SD-home-slider-02.ba343368.png";